function createStorageHelper (storage) {
  return {
    load (key) {
      if ([undefined, null].includes(key)) {
        throw new Error('[Local storage helper]: key field is required')
      }
      const stored = storage.getItem(key)
      try {
        return stored === null ? null : JSON.parse(stored)
      } catch (err) {
        console.debug(err, 'error getting local storage value for key', key)
        return null
      }
    },
    tryLoad (key) {
      if ([undefined, null].includes(key)) {
        return null
      }
      const stored = storage.getItem(key)
      try {
        return stored === null ? null : JSON.parse(stored)
      } catch (err) {
        console.debug(err, 'error getting local storage value for key', key)
        return null
      }
    },
    maybeLoadRaw (key) {
      if ([undefined, null].includes(key)) {
        return null
      }
      const stored = storage.getItem(key)
      try {
        return stored
      } catch (err) {
        console.debug(err, 'error getting local storage value for key', key)
        return null
      }
    },
    store (key, value) {
      if (typeof value === 'undefined') return

      storage.setItem(key, JSON.stringify(value))
    },
    tryStore (key, value) {
      try {
        if (typeof value === 'undefined') return

        storage.setItem(key, JSON.stringify(value))
      } catch (err) {
        console.debug(err, 'error setting local storage value for key', key)
      }
    },
    storeMany (keyValuePair) {
      Object.entries(keyValuePair).forEach(([key, value]) =>
        storage.setItem(key, JSON.stringify(value))
      )
    },
    modify (key, fn) {
      this.store(key, fn(this.load(key)))
    },
    removeItems (keys) {
      keys.forEach((key) => storage.removeItem(key))
    },
    tryRemove (key) {
      try {
        storage.removeItem(key)
      } catch (err) {
        console.debug(err, 'error removing local storage key', key)
      }
    },
    clear () {
      storage.clear()
    },
    /** Tries to load an object from local storage */
    loadOrDefault (key, defaults = {}) {
      if (!key) return defaults

      const configuration = this.load(key) || defaults

      return Object.entries(defaults).reduce((prev, [key, value]) => {
        if (key in configuration) {
          prev[key] = configuration[key]
        } else {
          prev[key] = value
        }
        return prev
      }, {})
    }
  }
}

export const localStorageHelper = createStorageHelper(localStorage)
export const sessionStorageHelper = createStorageHelper(sessionStorage)
